import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatButtonToggleChange } from "@angular/material/button-toggle";

import { Eligibility, EligibilityGrid, EligibilityPayload, EligibilityPayloadList, EligibilityQuestion } from "src/app/models/eligibility";

@Component({
    selector: 'mwp-benefit-enrollment-wizard-eligibility',
    templateUrl: './eligibility.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EligibilityComponent implements OnInit {
    @Input() public eligibility: Eligibility;
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    public eligibilityGrids: EligibilityGrid[];
    public eligibilityPayload: EligibilityPayload[] = new Array<EligibilityPayload>();
    public isPageValid: boolean;

    private gridTitles = {
		disabilityTitle: 'Spouse Or Child Currently Disabled',
		titleXIXTitle: 'Medicaid Coverage',
		spouseTitle: 'Spouse Coverage Exclusion',
		medicalTitle: 'Medical Coverage',
	};

    ngOnInit(){
        let l_EligibilityGridList: EligibilityGrid[] = new Array<EligibilityGrid>();
        let gridItem: EligibilityGrid;
        if (this.eligibility.showDisability) {
            gridItem = new EligibilityGrid();
            gridItem.title = this.gridTitles.disabilityTitle;
            gridItem.question = this.eligibility.disabilityQuestionForDisplay;
            gridItem.collection = this.eligibility.disabilityCollection;

            l_EligibilityGridList.push(gridItem);
        } 

        if (this.eligibility.showTitleXIX) {
            gridItem = new EligibilityGrid();
            gridItem.title = this.gridTitles.titleXIXTitle;
            gridItem.question = this.eligibility.titleXIXQuestionForDisplay;
            gridItem.collection = this.eligibility.titleXIXCollection;

            l_EligibilityGridList.push(gridItem);
        }

        if (this.eligibility.showSpouseCoverage) {
            gridItem = new EligibilityGrid();
            gridItem.title = this.gridTitles.spouseTitle;
            gridItem.question = this.eligibility.spouseQuestionForDisplay;
            gridItem.collection = this.eligibility.spouseCoverageCollection;

            l_EligibilityGridList.push(gridItem);
        }

        if (this.eligibility.showMedical) {
            gridItem = new EligibilityGrid();
            gridItem.title = this.gridTitles.medicalTitle;
            gridItem.question = this.eligibility.medicalQuestionForDisplay;
            gridItem.collection = this.eligibility.medicalCollection;

            l_EligibilityGridList.push(gridItem);
        }

        this.eligibilityGrids = l_EligibilityGridList;

        this.eligibilityGrids.forEach((eg: EligibilityGrid) => {
            eg.collection.forEach((c: EligibilityQuestion) => {
                const l_EligibilityPayload: EligibilityPayload = {
                      knockoutDependentID: c.knockoutDependentID,
                      isYesResponse: null,
                };
                this.eligibilityPayload.push(l_EligibilityPayload);
            });
        });
    }

    public eligibilitySelection(event: MatButtonToggleChange, id: string): void {
        let l_IsAllValid: boolean = true

        this.eligibilityPayload.forEach((ep: EligibilityPayload) => {
            if (ep.knockoutDependentID == id) {
                ep.isYesResponse = event.value;
            } else if (l_IsAllValid) {
                l_IsAllValid = ep.isYesResponse != null;
            }
        });

        this.isPageValid = l_IsAllValid;
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public submitComplete(): void {
        const l_EligibilityPayloadList: EligibilityPayloadList = {
            selectedCoverageEligibilityKnockouts: this.eligibilityPayload,
        };
        this.emitComplete.emit(l_EligibilityPayloadList);
    }
}
